var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgIconKakaotalkProduct(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.128,
    height: 35.946,
    viewBox: "0 0 39.128 35.946",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#391b1b;}.b{fill:#fae300;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-932 -672)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(932 672)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M74.662,77.391c-10.805,0-19.564,6.924-19.564,15.466,0,5.56,3.711,10.432,9.281,13.158-.409,1.528-1.482,5.535-1.7,6.392-.265,1.064.39,1.05.819.763.336-.224,5.361-3.639,7.529-5.114a24.774,24.774,0,0,0,3.631.267c10.8,0,19.564-6.926,19.564-15.467S85.467,77.391,74.662,77.391",
    transform: "translate(-55.098 -77.391)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.997 10.774)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M111.094,185.048h-5.721a.973.973,0,1,0,0,1.946h1.86v6.854a.952.952,0,0,0,.949.949h.208a.951.951,0,0,0,.948-.949v-6.854h1.757a.973.973,0,1,0,0-1.946Z",
    transform: "translate(-104.4 -184.911)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M263.8,191.75h-2.66v-7a1.055,1.055,0,1,0-2.111,0V192.3a1.026,1.026,0,0,0,.016.169.9.9,0,0,0-.016.168.883.883,0,0,0,.883.884H263.8a.883.883,0,0,0,0-1.767Z",
    transform: "translate(-243.361 -183.694)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M327.678,192.071l-2.965-3.894,2.679-2.68a.929.929,0,1,0-1.314-1.314l-3.316,3.316v-2.75a1.056,1.056,0,1,0-2.111,0v7.777a1.056,1.056,0,1,0,2.111,0v-2.4l.6-.6,2.8,3.68a.944.944,0,1,0,1.509-1.134Z",
    transform: "translate(-298.733 -183.694)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M175.918,192.324l-2.851-7.8-.009-.009a1.4,1.4,0,0,0-1.336-.821,1.361,1.361,0,0,0-1.386.982,1.3,1.3,0,0,0-.055.128l-2.8,7.52a.946.946,0,1,0,1.784.627l.485-1.385h3.9l.485,1.385a.946.946,0,1,0,1.784-.627Zm-5.552-2.525,1.311-3.741c.015,0,.028,0,.042,0l1.31,3.738Z",
    transform: "translate(-161.036 -183.694)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKakaotalkProduct);
export default __webpack_public_path__ + "static/media/icon_kakaotalk_product.f61b11f567aa740baf67ee483627e6d4.svg";
export { ForwardRef as ReactComponent };